import { render, staticRenderFns } from "./BizConfig.vue?vue&type=template&id=a4ed022e&scoped=true"
import script from "./BizConfig.vue?vue&type=script&lang=js"
export * from "./BizConfig.vue?vue&type=script&lang=js"
import style0 from "./BizConfig.vue?vue&type=style&index=0&id=a4ed022e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ed022e",
  null
  
)

export default component.exports